import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateTransferredItemsSeparationListReportInput } from './GenerateTransferredItemsSeparationListReportInput';
import { GenerateTransferredItemsSeparationListReportOutput } from './GenerateTransferredItemsSeparationListReportOutput';

export class GenerateTransferredItemsSeparationListReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GenerateTransferredItemsSeparationListReportInput) => {
    this.http.postToDownloadFile<GenerateTransferredItemsSeparationListReportInput>(
      `${this.baseUrlSislogApi}/v2/report-transferred-items-separation-list`,
      input
    ).then(result => {
      this.report.download(result, `${strings.TransferredItemsSeparationListReport}.csv`);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }

  handleCsvOrders = (input: GenerateTransferredItemsSeparationListReportInput): Promise<Result<GenerateTransferredItemsSeparationListReportOutput> | null> => {
    const promise = this.http.post<Result<GenerateTransferredItemsSeparationListReportOutput>, GenerateTransferredItemsSeparationListReportInput>(
      `${this.baseUrlSislogApi}/v2/report-transferred-items-separation-list/csv-separation-list`,
      input
    );
    return promise;
  }

}